import { IField } from 'utils/interfaces/IField';
import InputTypes from 'utils/enums/inputTypes';

const teachers: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do Professor',
        name: 'person.name',
        type: InputTypes.text,
        columns: 3
    }
];

export default teachers;
